// PanelAuditoriaLateral.jsx
import React, { useEffect, useState } from "react";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import PanelPrestacionesRelacionadas from "./PanelPrestacionesRelacionadas";
import PanelDetallePrestacion from "./PanelDetallePrestacion";
import { ModeloGetUrlJson } from "../../ModeloCrud";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useAuditoria } from "../contexts/AuditoriaContext";

export default function PanelAuditoriaLateral({
  prestacion,
  open,
  setOpen,
  width,
  setWidth,
}) {
  const handleToggle = () => setOpen(!open);
  const [relacionadas, setRelacionadas] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [coseguro, setCoseguro] = useState([]);
  const { updateAuditoria } = useAuditoria();

  const fetchRelacionadas = async () => {
    if (!prestacion) return;
    const ids = prestacion?.debitos_id?.trim();

    setRelacionadas([]);
    updateAuditoria({ fotoUrl: null });

    try {
      const params = new URLSearchParams({
        detalles_id: ids,
        plan_id: prestacion?.planes_prepaga_id,
        nomenclador_id: prestacion?.nomenclador_id,
        paciente_id: prestacion?.paciente_id,
        fecha: prestacion?.fecha,
      });
      const result = await ModeloGetUrlJson(
        "tratamiento",
        null,
        "tratamiento-detalles-auditoria",
        params
      );
      console.log("Resultado de relacionadas:", result);
      if (!result.error) {
        const relacionadasOrdenadas = Array.isArray(result.rechazoDetalle)
          ? [...result.rechazoDetalle].sort(
              (a, b) =>
                dayjs(b.fecha, "DD/MM/YYYY").unix() -
                dayjs(a.fecha, "DD/MM/YYYY").unix()
            )
          : [];
        setRelacionadas(relacionadasOrdenadas);
        setPagos(result.pagos || []);
        setCoseguro(result.coseguro || []);
        updateAuditoria({ fotoUrl: result.fotoUrl || null });
      } else {
        toast.error(
          "Error al cargar relacionadas: " + (result.mensaje ?? "desconocido")
        );
      }
    } catch (error) {
      console.error("Error al obtener relacionadas:", error);
      toast.error("Error al cargar prestaciones relacionadas");
    }
  };

  useEffect(() => {
    fetchRelacionadas();
  }, [prestacion]);

  return (
    <Box
      sx={{
        position: "relative",
        height: "100%",
        width: open ? width : 20,
        bgcolor: "#f9f9f9",
        borderRight: "1px solid #ccc",
        display: "flex",
        flexDirection: "column",
        transition: "width 0.2s",
        overflow: "hidden",
      }}
    >
      {/* Botón de colapsar */}
      <IconButton
        size="small"
        sx={{
          position: "absolute",
          right: -12,
          top: 10,
          zIndex: 1,
          bgcolor: "white",
          border: "1px solid #ccc",
        }}
        onClick={handleToggle}
      >
        {open ? (
          <ArrowBackIosIcon fontSize="small" />
        ) : (
          <ArrowForwardIosIcon fontSize="small" />
        )}
      </IconButton>

      {open && (
        <Box sx={{ p: 0, overflowY: "auto" }}>
          <PanelDetallePrestacion
            prestacion={prestacion}
            pagos={pagos}
            coseguro={coseguro}
          />
          <PanelPrestacionesRelacionadas
            relacionadas={relacionadas}
            heightLimit={200}
            onRefacturarDone={fetchRelacionadas}
          />
        </Box>
      )}
    </Box>
  );
}
